import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./App.jsx";
import DesktopApp from "./DesktopApp.jsx";
import SupportWidget from "./components/SupportWidget.jsx";
import GetTheApp from "./components/GetTheApp.jsx";
import AccountLinkPage from "./components/AccountLinkPage.jsx";
import { accountLinkKind } from "./lib/accountLinks.js";

const isMobile = window.matchMedia("(max-width: 768px)").matches;
// Links from account emails (password reset, email confirmation) work at any
// width, since they're usually opened on a phone.
const accountLink = accountLinkKind(window.location.pathname);

const root = createRoot(document.getElementById("root"));

// Phones get GetTheApp (a pointer to the iPhone app) instead of a web app:
// web sign-up and Stripe checkout are desktop-only by product decision.
// App.jsx's older mobile-width shell is no longer rendered; it still exports
// ThemeProvider/useTheme, which the SupportWidget and GetTheApp use.
//
// ThemeProvider wraps both the active shell and the SupportWidget (a
// sibling here, not a child) so they share one toggle.
// DesktopApp doesn't consume it yet — harmless no-op for that shell.
root.render(
  <StrictMode>
    <ThemeProvider>
      {accountLink ? <AccountLinkPage kind={accountLink} /> : isMobile ? <GetTheApp /> : <DesktopApp />}
      <SupportWidget />
    </ThemeProvider>
  </StrictMode>
);
